import { ApiState, Action } from '../../../../../types';
import { serviceReducer } from '../../../../../shared/hooks/serviceReducer';
import { ActionPlanItemContextType } from '../../../../../services/types/ActionPlan';

const actionPlanItemReducer = (
  state: ApiState<ActionPlanItemContextType, string>,
  action: Action<ActionPlanItemContextType, string>
): ApiState<ActionPlanItemContextType, string> => serviceReducer(state, action);

export default actionPlanItemReducer;
